import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { dayLimitArrangementSchema } from '../schema';
import { DayLimitArrangementFormValues } from '../types';
import { DayLimitArrangementForEmployeeResponse } from 'generated';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import useGetWorkAgreementDetails from 'components/shared/hooks/useGetWorkAgreementDetails';

export const useCreateEditForm = (
  row: DayLimitArrangementForEmployeeResponse | null | undefined,
  employeeId: number
) => {
  const { t } = useTranslation('common');
  const { data: workAgreements } = useGetWorkAgreementDetails(employeeId);

  const defaultValues: DayLimitArrangementFormValues = row
    ? {
        id: row.id,
        validFrom: row.validFrom ? dayjs(row.validFrom).toDate() : null,
        validTo: row.validTo ? dayjs(row.validTo).toDate() : null,
        employmentId: row.employment?.entityId ?? null,
        maxNumberOfDays: row.maxNumberOfDays,
        dayLimitArrangementNotApplicableForEmployee:
          row.dayLimitArrangementNotApplicableForEmployee ?? false,
        alternativePeriod: Boolean(row.alternativeTimeUnit),
        alternativeTimeUnit:
          row.alternativeTimeUnit === 'MONTH' ||
          row.alternativeTimeUnit === 'CUSTOM'
            ? row.alternativeTimeUnit
            : undefined,
        alternativeNrOfPeriods: row.alternativeNrOfPeriods,
        startDateForAlternativePeriod: row.startDateForAlternativePeriod
          ? dayjs(row.startDateForAlternativePeriod).toDate()
          : null
      }
    : {
        validFrom: null,
        validTo: dayjs('2099-01-01').toDate(),
        employmentId: null,
        maxNumberOfDays: undefined,
        dayLimitArrangementNotApplicableForEmployee: false,
        alternativePeriod: false,
        alternativeTimeUnit: undefined,
        alternativeNrOfPeriods: undefined,
        startDateForAlternativePeriod: null
      };

  return useForm<DayLimitArrangementFormValues>({
    resolver: yupResolver(dayLimitArrangementSchema(t, workAgreements)),
    defaultValues,
    mode: 'onChange'
  });
};

export default useCreateEditForm;
